<template>
  <div class="category-page">
    <Search/>
    <div class="category-page__title">
      <div class="category-page__title-wrap">
        <h1 class="main-title">
          {{ name }}
        </h1>
        <p class="category-page__subtitle">
          (Total Found: <strong>{{ total }}</strong
        >)
        </p>
      </div>
      <div class="category-page__select-wrap">
        <Pagination :gridList="true"/>
      </div>
    </div>
<!--    <Categories />-->
    <div class="category-page__body">
      <div class="category-page__col" :class="{ active: isMapOpen }">
        <Products/>
      </div>
      <div
          class="category-page__col category-page__col--map"
          :class="{ active: isMapOpen }"
      >
        <GoogleMap v-if="isMapOpen"/>
      </div>
    </div>
    <Pagination/>
    <section class="description description--category description--left-desc">
      <div class="description__wrap " v-html="description">

      </div>
    </section>
   <MobMapBtn />
  </div>
  <div></div>
</template>

<script setup lang="ts">
import Products from "../components/category-page/Products";
import Search from "../components/category-page/Search.vue";
// import Categories from "../components/category-page/Categories";
import Pagination from "../components/category-page/Pagination";
import MobMapBtn from "../components/category-page/MobMapBtn";
import GoogleMap from "../components/product-page/GoogleMap.vue";
import {useCategoryStore} from "../store/category";
import {useMapStore} from "../store/map.ts";
import {storeToRefs} from "pinia";
import {useProductStore} from "../store/product.ts";

const categoryStore = useCategoryStore();
const {name} = storeToRefs(categoryStore)
const {description} = categoryStore;
const {isMapOpen} = storeToRefs(useMapStore())

const {total} = storeToRefs(useProductStore())

</script>
